<template>
  <div>
    <v-container>
      <v-form>
        <v-row>
          <h2 class="pb-5">
            {{ this.parentObject.pageTitle }}
            <span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span>
          </h2>
        </v-row>

        <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">

          <v-row>
            <v-col cols="6" sm="6" class="pb-n4">
              <v-text-field
                outlined
                :label="this.$t('setuppattern.name')"
                type="text"
                ref="name"
                :rules="[rules.required]"
                v-model="formData.name"
                @input="updateValue"
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="3" sm="3" class="pb-n4">
              <v-text-field
                outlined
                :label="this.$t('columns.code')"
                type="text"
                ref="code"
                :rules="[rules.required]"
                v-model="formData.code"
                @input="updateValue"
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" sm="3" class="pb-n4 mt-n8">
              <v-text-field
                outlined
                :label="this.$t('setuppattern.cycledays')"
                type="number"
                ref="cycledays"
                :rules="[rules.required]"
                v-model="formData.cycledays"
                @input="updateValue"
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" class="pb-n4 mt-n8">
              <v-text-field
                outlined
                :label="this.$t('columns.remark')"
                type="text"
                ref="remark"
                v-model="formData.remark"
                @input="updateValue"
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" class="pb-n4 mt-n8">
              <p class="blue--text font-weight-bold mb-1">{{ $t('setuppattern.holidayaction') }}</p>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" sm="3" class="pb-n4 mt-n4">
              <v-autocomplete
                outlined
                :label="$t('setuppattern.rdaygzaction')"
                v-model="formData.rdaygzactionid"
                :items="actionTypeList"
                @input="updateValue"
                dense
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" sm="3" class="pb-n4 mt-n4">
              <v-autocomplete
                outlined
                :label="$t('setuppattern.rdayngzaction')"
                v-model="formData.rdayngzactionid"
                :items="actionTypeList"
                @input="updateValue"
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" sm="3" class="pb-n4 mt-n8">
              <v-autocomplete
                outlined
                :label="$t('setuppattern.ofdaygzaction')"
                v-model="formData.ofdaygzactionid"
                :items="actionTypeList"
                @input="updateValue"
                dense
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" sm="3" class="pb-n4 mt-n8">
              <v-autocomplete
                outlined
                :label="$t('setuppattern.ofdayngzaction')"
                v-model="formData.ofdayngzactionid"
                :items="actionTypeList"
                @input="updateValue"
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="4" class="pb-n4 mt-n8">
              <v-checkbox
                outlined
                ref="disable"
                v-model="formData.disable"
                :label="this.$t('columns.disable')"
                @change="updateValue"
                dense
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row v-if="this.parentObject.isEdit">
            <v-col cols="12" sm="12" class="pb-4">
              <p class="blue--text font-weight-bold">{{ $t('setuppattern.patterndetail') }}</p>
              <app-table
                v-bind:parentObject="{
                  tabHeader: this.tabHeader,
                  detailItem: this.formData.patternd,
                  patternid: this.formData.id,
                  userid: this.formData.userid,
                  cycledays: this.formData.cycledays,
                }"
                v-on:input="addDetailHandler"
              />
            </v-col>
          </v-row>

        </v-container>

        <app-formbuttons
          v-bind:EditBool="this.parentObject.isEdit"
          v-on:NewPressed="newHandler"
          v-on:SavePressed="saveHandler"
          v-on:DeletePressed="deleteHandler"
          v-on:CancelPressed="cancelHandler"
        />
      </v-form>
    </v-container>
  </div>
</template>

<script>
import CRUDTable from "./CRUDTable";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-table": CRUDTable,
  },

  data() {
    return {
      rules: {
        required: value => !!value || this.$t('reportsparam.required'),
      },
      actionTypeList: [],
      formData: {
        id: this.parentObject.data.id,
        code: this.parentObject.data.code,
        name: this.parentObject.data.name,
        cycledays: this.parentObject.data.cycledays,
        remark: this.parentObject.data.remark,
        rdaygzactionid:  this.parentObject.data.rdaygzactionid,
        rdayngzactionid: this.parentObject.data.rdayngzactionid,
        ofdaygzactionid:  this.parentObject.data.ofdaygzactionid,
        ofdayngzactionid: this.parentObject.data.ofdayngzactionid,
        disable: this.parentObject.data.disable,
        patternd: this.parentObject.data.patternd,
        stamp: this.parentObject.data.stamp,
        userid: this.parentObject.data.userid,
      },
      tabHeader: [
        { text: this.$t('columns.actions'), value: "action", width: "100px", sortable: false },
        { text: this.$t('setuppattern.sequenceno'), value: "sequenceno", width: "100px", sortable: false },
        { text: this.$t('setuppattern.shiftcode'), value: "shiftcode", width: "150px", sortable: false },
        { text: this.$t('setuppattern.shiftdesc'), value: "shiftdesc", width: "200px", sortable: false },
        { text: this.$t('setuppattern.daytypecode'), value: "daytypecode", width: "150px", sortable: false },
        { text: this.$t('setuppattern.daytypedesc'), value: "daytypedesc", width: "150px", sortable: false },
      ],
      errMsg: "",
      isErr: false,
      search: this.parentObject.searchnew,
    };
  },

  methods: {
    loadActionTypes() {
      this.$store.dispatch('get', { url: '/actiontype/all' })
        .then(res => {
          this.actionTypeList = res.data.rec.map(r => ({ text: r.actiontype, value: r.id }));
        })
        .catch(err => console.error(err));
    },

    addDetailHandler($event) {
      this.formData.patternd = $event;
    },

    updateValue() {
      this.$emit("input", {
        id: this.formData.id,
        code: this.formData.code,
        name: this.formData.name,
        cycledays: this.formData.cycledays,
        remark: this.formData.remark,
        rdaygzactionid:  this.formData.rdaygzactionid,
        rdayngzactionid: this.formData.rdayngzactionid,
        ofdaygzactionid:  this.formData.ofdaygzactionid,
        ofdayngzactionid: this.formData.ofdayngzactionid,
        disable: this.formData.disable,
        patternd: this.formData.patternd,
        stamp: this.formData.stamp,
        userid: this.formData.userid,
      });
    },

    newHandler() {
      this.$emit("new");
    },

    saveHandler() {
      this.updateValue();
      this.$emit("save");
    },

    deleteHandler() {
      this.$emit("delete");
    },

    cancelHandler() {
      this.$router.push({ name: "patternsetuplist", params: { search: this.search } });
    },
  },

  mounted() {
    this.loadActionTypes();
  },
};
</script>
